import React, { FC } from "react";

/**
 * @author
 * @function @ViewGraphicSvg
 **/

const ViewGraphicSvg: FC = () => {
    return (
        <svg
            width="52"
            height="32"
            viewBox="0 0 52 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="51"
                height="31"
                rx="15.5"
                fill="#023E65"
            />
            <path
                d="M33.5 17.6666H32.6666V8.49996C32.6666 8.27895 32.5788 8.06698 32.4225 7.9107C32.2663 7.75442 32.0543 7.66663 31.8333 7.66663H20.1666C19.9456 7.66663 19.7337 7.75442 19.5774 7.9107C19.4211 8.06698 19.3333 8.27895 19.3333 8.49996V17.6666H18.5C18.2789 17.6666 18.067 17.7544 17.9107 17.9107C17.7544 18.067 17.6666 18.2789 17.6666 18.5C17.6666 18.721 17.7544 18.9329 17.9107 19.0892C18.067 19.2455 18.2789 19.3333 18.5 19.3333H25.1666V20.2916L21.375 22.7916C21.2194 22.8879 21.0999 23.0327 21.0348 23.2037C20.9697 23.3747 20.9627 23.5623 21.0148 23.7377C21.0669 23.913 21.1753 24.0664 21.3232 24.174C21.4712 24.2816 21.6504 24.3376 21.8333 24.3333C21.9971 24.3352 22.1574 24.2856 22.2916 24.1916L25.1666 22.2916V23.5C25.1666 23.721 25.2544 23.9329 25.4107 24.0892C25.567 24.2455 25.7789 24.3333 26 24.3333C26.221 24.3333 26.4329 24.2455 26.5892 24.0892C26.7455 23.9329 26.8333 23.721 26.8333 23.5V22.2916L29.7083 24.1916C29.8425 24.2856 30.0028 24.3352 30.1666 24.3333C30.3447 24.3319 30.5176 24.2736 30.66 24.1668C30.8025 24.06 30.907 23.9104 30.9583 23.7398C31.0095 23.5693 31.0048 23.3869 30.9448 23.2193C30.8848 23.0516 30.7727 22.9076 30.625 22.8083L26.8333 20.3083V19.3333H33.5C33.721 19.3333 33.9329 19.2455 34.0892 19.0892C34.2455 18.9329 34.3333 18.721 34.3333 18.5C34.3333 18.2789 34.2455 18.067 34.0892 17.9107C33.9329 17.7544 33.721 17.6666 33.5 17.6666ZM31 17.6666H21V9.33329H31V17.6666ZM23.5 16C23.6372 15.9992 23.7722 15.9646 23.8928 15.8992C24.0135 15.8338 24.1161 15.7396 24.1916 15.625L25.3 13.9583L26.2416 14.9083C26.3291 14.9963 26.435 15.0636 26.5518 15.1054C26.6686 15.1472 26.7932 15.1625 26.9166 15.15C27.0395 15.1365 27.1578 15.0958 27.263 15.031C27.3682 14.9661 27.4577 14.8787 27.525 14.775L29.1916 12.275C29.2898 12.092 29.3161 11.879 29.2654 11.6776C29.2147 11.4763 29.0907 11.3011 28.9176 11.1864C28.7445 11.0717 28.5348 11.0257 28.3297 11.0575C28.1245 11.0893 27.9385 11.1966 27.8083 11.3583L26.7 13.025L25.7583 12.075C25.6709 11.987 25.5649 11.9196 25.4481 11.8778C25.3313 11.836 25.2067 11.8208 25.0833 11.8333C24.9604 11.8468 24.8421 11.8874 24.7369 11.9523C24.6317 12.0171 24.5422 12.1046 24.475 12.2083L22.8083 14.7083C22.6877 14.892 22.6445 15.1159 22.6882 15.3313C22.7319 15.5467 22.8589 15.7361 23.0416 15.8583C23.1758 15.9523 23.3361 16.0018 23.5 16Z"
                fill="white"
            />
            <rect
                x="0.5"
                y="0.5"
                width="51"
                height="31"
                rx="15.5"
                stroke="#023E65"
            />
        </svg>
    );
};

export default ViewGraphicSvg
